<script context="module">
  /**
   * IDs of Media items that are coming soon and should be disabled for now.
   */
  export const comingSoonMediaItemIds = [
    // "25dbf092-4505-4d28-bebf-6a6e9b7bf9de", // Series Prologue
    "e731b3ca-1f69-47b9-b1e7-1490c8df8b0b", // CH001 Mark
    "40471260-59ff-4b0c-9d48-9d47bf902f9f", // CH002 Pablo
    "9f135cd3-cb71-4ecf-b918-ff58ebba95b9", // CH003 Leo
    "9b3195df-b0f1-4522-834b-f7ae9690558f", // CH004 Sam
  ];
</script>

<script lang="ts">
  import SectionDivider from "@components/layout/SectionDivider.svelte";
  import type { CustomMediaItem } from "@customTypes/entries";
  import { type CardProps } from "@components/content/Card.svelte";
  import { convertStatamicAssetToCDN } from "@utils/cdn";
  import CardSlider from "@components/content/CardSlider.svelte";

  export let section_title = "";
  export let link_to_more = "";
  export let media_items: CustomMediaItem[];
  export let currentItem: number = 0;
  export let slides;

  export let focused_item: number;

  let focusedItem =
    typeof focused_item === "number" ? focused_item : currentItem + 1;

  function convertCustomMediaItemToCard(
    mediaItem: CustomMediaItem,
  ): CardProps | {} {
    // Not proud of this, but needed to get something out the door since the more flexible component isn't ready yet.
    if (mediaItem.id === "WAH_SERIES_TRAILER") {
      const cardProps: CardProps = {
        title: "Wild At Heart: The Series | Official Trailer (2024)",
        description: `"Wild at Heart: The Series" invites you into the stories of four men as they bravely confront their deepest wounds, discover their true identity, and experience something of the wild goodness of God. Inspired by the bestselling book Wild at Heart by John Eldredge.`,
        trimDescriptionBool: false,
        tag: `Trailer`,
        featuredImageSrc: convertStatamicAssetToCDN(
          "wp-app/uploads/2024/the-series/the-series-social-share.jpg",
        ),
        href: "https://www.youtube.com/watch?v=WXe4GhWn0uc",
        rightCTA: {
          text: `Play Trailer`,
          href: "https://www.youtube.com/watch?v=WXe4GhWn0uc",
          open_in_new_tab: true,
          leftIcon: { name: "play" },
        },
      };
      return cardProps;
    }
    const { title, description, media_type, position } = mediaItem;
    const isComingSoon = mediaItem.is_coming_soon;
    const output: CardProps = {
      title,
      description,
      trimDescriptionBool: false,
      href: isComingSoon ? undefined : mediaItem.uri,
      tag: `${media_type}${!!position ? " " + position : ""}`,
      details: isComingSoon ? "Coming Soon" : undefined,
      featuredImageSrc: convertStatamicAssetToCDN(mediaItem?.images?.wide?.id),
      isFocused: focusedItem === mediaItem.position,
      isDisabled: isComingSoon,
      rightCTA: {
        text: `Play ${media_type}`,
        href: mediaItem.uri,
        leftIcon: { name: "play" },
      },
    };
    return output;
  }

  function convertSlideToCard(slide): CardProps {
    // Ensure the date is in UTC so it can be converted to the user's local time
    const date = slide.date ? new Date(slide.date + "Z") : undefined;

    if (slide.collection?.handle === "blogs") {
      return slide;
    }

    return {
      leader: slide.leader,
      title: slide.title,
      subtitle: slide?.subtitle,
      description: slide.description,
      featuredImageSrc: slide.featured_image_src,
      href: slide.href,
      tag: slide.tag,
      details: slide.details,
      trimDescriptionBool: slide.trim_description_bool,
      isFocused: focusedItem === slide.position,
      leftCTA: slide.left_cta,
      isDisabled: slide.is_coming_soon,
      // variant: slide?.variant,
      variant: slide?.variant === "portrait" ? "default" : slide?.variant,
      // rightCTA: slide.right_cta,
      rightCTA:
        date && date > new Date()
          ? date.toLocaleDateString("en-US", {
              weekday: "long",
              month: "long",
              day: "numeric",
              year: "numeric",
            })
          : slide.right_cta,
    };
  }
</script>

{#if media_items.length}
  {#if section_title}
    <SectionDivider title={section_title} />
  {/if}
  <CardSlider
    startIndex={focusedItem}
    cards={media_items.map(convertCustomMediaItemToCard)}
  />
{/if}

{#if slides?.length}
  {#if section_title}
    <SectionDivider
      title={section_title}
      moreButton={link_to_more
        ? { text: "Explore All", href: link_to_more }
        : null}
    />
  {/if}
  <CardSlider startIndex={focusedItem} cards={slides.map(convertSlideToCard)} />
{/if}
